exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-outline[data-v-33a74b4a]{background-color:#fff;color:#000;-webkit-box-shadow:inset 0px 0px 0 1px black;box-shadow:inset 0px 0px 0 1px black;font-weight:600;-webkit-transition:all 0.3s;-o-transition:all 0.3s;transition:all 0.3s}@media screen and (min-width: 900px){.button-outline[data-v-33a74b4a]{min-width:160px}}.dark[data-v-33a74b4a]:hover,.dark[data-v-33a74b4a]:focus{background-color:#000;color:#fff}.light[data-v-33a74b4a]:hover,.light[data-v-33a74b4a]:focus{background-color:#000;color:#fff}.disabled[data-v-33a74b4a]{opacity:0.3}\n", ""]);

// exports
